import { combineReducers } from 'redux'

import courseReducer from './slices/course'

const rootReducer = combineReducers({
  course: courseReducer
})

export { rootReducer }
